import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import type { ItemStatus } from "@/types/tina";

const STYLES: Record<ItemStatus, string> = {
  pending: "bg-muted text-foreground",
  in_progress: "bg-blue-500/15 text-blue-700 dark:text-blue-300",
  waiting_on_primary: "bg-violet-500/15 text-violet-700 dark:text-violet-300",
  failed_retryable: "bg-amber-500/15 text-amber-700 dark:text-amber-300",
  failed: "bg-red-500/15 text-red-700 dark:text-red-300",
  done: "bg-emerald-500/15 text-emerald-700 dark:text-emerald-300",
  skipped: "bg-zinc-500/15 text-zinc-700 dark:text-zinc-300",
  duplicate: "bg-zinc-500/15 text-zinc-700 dark:text-zinc-300",
  cancelled: "bg-zinc-500/15 text-zinc-700 dark:text-zinc-300",
  hitl: "bg-orange-500/15 text-orange-700 dark:text-orange-300",
};

export function ItemStatusBadge({ status }: { status: ItemStatus }) {
  return <Badge className={cn(STYLES[status])}>{status}</Badge>;
}
